<template>
  <div class="container">
   Name of the show<br/>
    homepage of the show<br/>
    tv station<br/>
    social media profiles<br/>
    art image???<br/>
    <form @submit.prevent="setShow(entity)">
<p>
        <label for="question">Show Title</label>
        <input class="form-control" id="question" v-model="entity.title" placeholder="TV Show Name">
      </p><h3>Choices</h3>
        <!-- <input class="form-control" id="choiceA" v-model="question.choice" placeholder="A">
        <input class="form-control" id="choiceB" v-model="question.choice" placeholder="B">
        <input class="form-control" id="choiceC" v-model="question.text" placeholder="C">
        <input class="form-control" id="choiceD" v-model="question.text" placeholder="D"> -->
        <input class="btn btn-success" type="submit" />
    </form>
  </div>
</template>

<script>
import db from "../../../../lib/db"
export default {
  name: 'CreateShow',
  props: {
    msg: String
  },
  data(){
      return{
          entity: {
              title: "",
              homepage: "",
              art: "",
              station: "",
              social: ""
          }
      }
  },
  created() {},
  methods: {
      setShow: function (entity) {
        let showRef = db.getRef().ref('show')
        let show = {
            title: entity.title,
              homepage: entity.homepage,
              art: entity.art,
              station: entity.station,
              social: entity.social
        }
        showRef.push(show).then((ref) => {
            console.log('ref /, ', ref.key)
            showRef.child(ref.key).update({id: ref.key})

        })
      },
  },
  components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
